<template>
    <h1>Not Found</h1>
    <router-link :to="{name: 'EventList'}">
        Go back now!
    </router-link>
</template>